import * as React from 'react';
import styled from 'styled-components';
import _ from 'lodash';

const ShowDistance = 200;
const ThrottleCallFrequency = 250;

export interface BackToTopButtonInternalState {
  visible: boolean;
}

export interface BackToTopButtonOwnProps {
  style?: object;
}

const StyledButton = styled.button`
  position: fixed;
  bottom: 15px;
  right: 15px;
  z-index: 1000;
  border-radius: 50%;
  height: 45px;
  width: 45px;
  background: #0078ae;
  color: white;
  border: none;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2),
    0 6px 10px 0 rgba(0, 0, 0, 0.14),
    0 1px 18px 0 rgba(0, 0, 0, 0.12);
  -webkit-animation: fadein 0.75s;
  -moz-animation: fadein 0.75s;
  -ms-animation: fadein 0.75s;
  -o-animation: fadein 0.75s;
  animation: fadein 0.75s;

  &:hover {
    background: #00557b;
    text-shadow: 0 0 20px white;
    transition: text-shadow 150ms cubic-bezier(0.64, 0.29, 0.75, 0.75),
      background 150ms cubic-bezier(0.64, 0.29, 0.75, 0.75),
      color 150ms cubic-bezier(0.64, 0.29, 0.75, 0.75);
    }

  .ns-icon::before {
    margin-right: 0;
  }

  @keyframes fadein {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @-moz-keyframes fadein {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @-webkit-keyframes fadein {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @-ms-keyframes fadein {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @-o-keyframes fadein {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const srollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

export class BackToTopButton extends React.Component<BackToTopButtonOwnProps, BackToTopButtonInternalState> {
  state = {
    visible: false
  };

  componentDidMount() {
    window.addEventListener('scroll', this.throttleFn);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.throttleFn);
  }

  didScroll = () => {
    if (window.pageYOffset > ShowDistance && !this.state.visible) {
      this.setState({ visible: true });
    }

    if (window.pageYOffset < ShowDistance && this.state.visible) {
      this.setState({ visible: false });
    }
  }

  throttleFn = _.throttle(this.didScroll, ThrottleCallFrequency);

  render() {
    if (!this.state.visible) {
      return null;
    }

    return (
      <StyledButton onClick={srollToTop} style={this.props.style}>
        <span className="ns-icon ns-collapse" />
      </StyledButton>
    );
  }
}
